var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-indicator-new",class:{ 'progress-indicator-new--highlighted': _vm.isProgressFinished }},[_c('ProgressBarNew',{attrs:{"progress":_vm.progressInPercent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }